import { useState, useEffect } from 'react'

export function useCountdown(initialSeconds: number = 85631) {
  const [timeLeft, setTimeLeft] = useState(initialSeconds)

  useEffect(() => {
    if (timeLeft <= 0) return

    const intervalId = setInterval(() => {
      setTimeLeft((prev) => prev - 1)
    }, 1000)

    return () => clearInterval(intervalId)
  }, [timeLeft])

  const hours = Math.floor(timeLeft / 3600)
  const minutes = Math.floor((timeLeft % 3600) / 60)
  const seconds = timeLeft % 60

  const format = (num: number) => String(num).padStart(2, '0')

  return {
    hours: format(hours),
    minutes: format(minutes),
    seconds: format(seconds),
    isExpired: timeLeft <= 0,
  }
}
